import { render, staticRenderFns } from "./create-custom-field-form.vue?vue&type=template&id=8334da4a"
import script from "./create-custom-field-form.vue?vue&type=script&lang=js"
export * from "./create-custom-field-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports